/* @flow weak */

'use strict';

const React = require('react');
const ControlMixin = require('../../mixins/ControlMixin.jsx');
const Config = require('../../configs/Config.js');

const QuestionStore = require('../../stores/QuestionStore.jsx');
const UCStore = require('../../stores/UCStore.jsx');
const ValidatorStore = require('../../stores/ValidatorStore.jsx');

const _ = require('lodash');
const Loader = require('../../loaders');
const ln = Loader.ln || 'en_US';

const ComplexDropdownSelect = React.createClass({
    mixins: [ControlMixin],

    getInitialState() {
        return {
            'category': undefined,
            'typeahead': undefined
        };
    },

    getCategoryList() {
        let partCategories = _.chain(this.props.parts)
            .map((parts) => {
                return parts.category;
            })
            .flattenDeep()
            .uniq()
            .filter((category) => {
                return category !== undefined && category !== null;
            })
            .value();

        let categories = UCStore.getCategories();

        partCategories = _.map(partCategories, (category) => {
            return _.find(categories, { 'id': category });
        });

        return _.sortBy(partCategories, 'name');
    },

    filterParts() {
        let parts = this.props.parts;

        if (this.state.category) {
            parts = _.filter(parts, (part) => {
                return _.indexOf(part.category, this.state.category) !== -1;
            });
        }

        if (this.state.typeahead) {
            parts = _.filter(parts, (part) => {
                let name = _.get(part, `metadata.lang.${ln}.DisplayName`);
                if (!name) {
                    return false;
                }

                return name.toLowerCase().indexOf(this.state.typeahead) !== -1;
            });
        }

        return parts;
    },

    generateOptions() {
        return _.map(this.filterParts(), part => {
            return (
                <option
                    className='uc-c uc-c-dropdown-option'
                    value={part.id}
                    key={part.id}>
                    {this.displayPartName(part)} {this.displayPrice(part)}
                </option>
            );
        });
    },

    handleCategoryChange(e) {
        this.setState({
            'category': e.target.value
        });
    },

    handleTypeaheadChange(e) {
        this.setState({
            typeahead: e.target.value.toLowerCase()
        });
    },

    render() {
        let categories = this.getCategoryList();
        let firstOptionText = _.get(this.props.question, 'metadata.control.Choose.FirstOptionCustomText') || Config.features.chooseDropdownText[ln] || Config.features.chooseDropdownText['en_US']; 
        let categoryFilter = null;
        let selectID = `uc-c-${this.props.question.id}`;
        let questionName = _.get(this.props.question, `metadata.lang.${ln}.DisplayName`) || _.get(this.props.question, 'name');
        if (categories.length > 1) {
            categoryFilter = <div className='uc-cis-filters-category'>
                <select aria-label={questionName + ' categories'}
                    onChange={this.handleCategoryChange} tabIndex={this.props.tabIndex}>
                    <option value=''>Filter by Category...</option>
                    {_.map(categories, (category, index) => {
                        return (
                            <option value={category.id} key={index}>{category.name}</option>
                        );
                    })}
                </select>
            </div>;
        }

        return (
            <div className='uc-control uc-complex-dropdown'>
                {!this.state.locked ? (
                    <div className='uc-cis-filters'>
                        {categoryFilter}
                        <div style={{ display: this.props.parts.length < 10 || !!_.get(this.props.question.metadata, 'HideSearchField') ? 'none' : 'block' }} className='uc-cis-filters-typeahead'>
                            <input aria-label="Search options" type='text' placeholder='Search' onChange={this.handleTypeaheadChange} tabIndex={this.props.tabIndex} />
                        </div>
                    </div>
                ) : null
                }

                {_.get(this.props.question.metadata, 'DisplayQuestionTitleInControl') ? (
                    <div className="uc-question-header">
                        <div className={this.props.question.parent_id !== null ? 'uc-child-question-title' : 'uc-question-title'}>
                            {_.get(this.props.question.metadata, `lang.${ln}.DisplayName`) || this.props.question.name}
                        </div>
                    </div>
                ) : null
                }
                    <select
                        aria-label={questionName}
                        name='uc-dropdown-select'
                        value={this.state.answer}
                        onChange={this.handleChange}
                        tabIndex={this.props.tabIndex}
                        disabled={this.state.locked}>
                        <option value="">{firstOptionText}</option>
                        {this.generateOptions()}
                    </select>
            </div>
        );
    }
});

module.exports = ComplexDropdownSelect;



// WEBPACK FOOTER //
// ./src/base/scripts/components/controls/ComplexDropdownSelect.jsx